// extracted by mini-css-extract-plugin
export default {"comments":"Comments_comments__wQg26","title":"Comments_title__tT3p8","title__span":"Comments_title__span__raSg+","comments__posts":"Comments_comments__posts__8A1w1"};